// A type alias, not an interface: the side menu hands these to a
// Record<string, unknown>[], which only a type literal is assignable to.
export type NavItem = {
    text: string;
    path?: string;
    icon?: string;
    items?: NavItem[];
    // Listed in the page dropdown of embedded mode (`?embeded=true`, see
    // EmbededModeService). Set it only on pages built to run inside a host
    // app's iframe — today, the ones with "Load Lnwshop Data".
    showInEmbeded?: boolean;
};

export const navigation: NavItem[] = [
    {
        text: 'All Stores',
        path: 'secure/orders/all',
        icon: 'home',
    },
    {
        text: 'Operations',
        icon: 'product',
        items: [
            {
                text: 'Split View',
                path: 'secure/orders/quick',
            },
            {
                text: 'Lazada',
                path: 'secure/orders/lazada',
            },
            {
                text: 'Shopee Gen4',
                path: 'secure/orders/shopee/gen4',
            },
            {
                text: 'Shopee GenLogic',
                path: 'secure/orders/shopee/genlogic',
            },
            {
                text: 'TikTok',
                path: 'secure/orders/tiktok',
            },
            {
                text: 'พัสดุคืนสินค้า',
                path: 'secure/orders/returns',
            },
        ],
    },
    {
        text: 'เอกสารขาย',
        icon: 'textdocument',
        items: [
            {
                text: 'ออกใบเสนอราคา',
                path: 'secure/billings/quote-generator',
                showInEmbeded: true,
            },
            {
                text: 'ออกใบกำกับภาษี',
                path: 'secure/billings/tax-invoice',
                showInEmbeded: true,
            },
            {
                text: 'ออกใบส่งของชั่วคราว',
                path: 'secure/billings/temp-delivery-note',
                showInEmbeded: true,
            },
            {
                text: 'ออกใบเสร็จรับเงิน',
                path: 'secure/billings/receipt-note',
            },
        ],
    },
    {
        text: 'การเงิน',
        icon: 'money',
        items: [
            {
                text: 'รายได้และค่าธรรมเนียม',
                path: 'secure/finance/revenue-fees',
            },
        ],
    },
    {
        text: 'ภาษี',
        icon: 'taskhelpneeded',
        items: [
            {
                text: 'รายงานภาษีขาย',
                path: 'secure/tax/output-tax/summary',
            },
            {
                text: 'สร้างฟอร์มขอใบกำกับภาษี',
                path: 'secure/tax/input-tax/req/create',
            },
            {
                text: 'จัดการข้อมูลใบกำกับภาษี',
                path: 'secure/tax/input-tax/req/manage',
            },
        ],
    },
    {
        text: 'Utilities',
        icon: 'toolbox',
        items: [
            {
                text: 'สินค้าคงคลัง',
                path: 'secure/inventory/inventory-list',
            },
            {
                text: 'Reordering Calc',
                path: 'secure/utilities/reordering',
            },
            // {
            //     text: 'ค้นหาคู่ค้า',
            //     path: 'embeded/ctp-finder',
            // },
        ],
    },
    {
        text: 'Analytic Tools',
        icon: 'datafield',
        items: [
            {
                text: 'Sale by Time',
                path: 'secure/sale/time',
            },
        ],
    },
    {
        text: 'Settings',
        icon: 'preferences',
        items: [
            {
                text: 'APIs Authorization',
                path: 'secure/settings/api-auth',
            },
            {
                text: 'Service Monitor',
                path: 'secure/settings/svc-mon',
            },
            {
                text: 'Crawler Monitor',
                path: 'secure/settings/crawler-mon',
            },
        ],
    },
];
